var map = {
	"./amex-card.svg": 92503,
	"./diners-card.svg": 37147,
	"./discover-card.svg": 96952,
	"./jcb-card.svg": 22177,
	"./mastercard-card.svg": 30998,
	"./unionpay-card.svg": 89543,
	"./unknown-card.svg": 58952,
	"./visa-card.svg": 52092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42976;